import React from 'react';
import { browserHistory } from 'react-router';
import {
  isMobileDevice,
  setResponsiveMode,
  setFullSiteMeta,
} from 'utils/fullSite';
import {
  mWebAppsStart as mWebAppsStartClevertap,
  mWebAppsCta as mWebAppsCtaClevertap,
} from 'clevertap/mWebFullSiteSwitch';
import styles from './OpenPlatform.css';
import welcomeImage from './images/apps_landing_img.png';

function MobileLandingPage(props) {
  return (
    <div className={styles.container}>
      <img src={welcomeImage} className={styles.welcomeImage} />
      <div className={styles.text}>
        <b className={styles.title}>Apps</b>
        <br />
        Integrate your account with various supporting business solution from
        Moka trusted partners with just a few clicks.
      </div>
      <button
        className={`btn btn-primary ${styles.button}`}
        onClick={props.onClickSwitchButton}
      >
        Explore App Marketplace
      </button>
    </div>
  );
}

class OpenPlatform extends React.Component {
  handleSwitchToFullSite = () => {
    // Disable responsive view
    setFullSiteMeta();
    // To keep user in full site mode when refreshing page
    setResponsiveMode(false);

    // Redirect to default landing page
    browserHistory.push('/apps/app-market');

    mWebAppsCtaClevertap();
  };

  componentDidMount() {
    if (isMobileDevice()) {
      mWebAppsStartClevertap();
    }
  }

  render() {
    if (isMobileDevice()) {
      return (
        <MobileLandingPage onClickSwitchButton={this.handleSwitchToFullSite} />
      );
    }

    return <div className={styles.wrapper}>{this.props.children}</div>;
  }
}

export default OpenPlatform;
